// extracted by mini-css-extract-plugin
export const profile__photo = "profile-module--profile__photo--r-HG2";
export const profile__title = "profile-module--profile__title--2IJCt";
export const profile__titleLink = "profile-module--profile__title-link--1_tip";
export const profile__subtitle = "profile-module--profile__subtitle--2RU9i";